import { JSONContent } from '@tiptap/core'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-expect-error
import { DraftConverter } from '@tiptap/draftjs-to-tiptap'
import { RawDraftContentBlock } from 'draft-js'

const removeEmptyTextNodes = (node: JSONContent) => {
  if (Array.isArray(node.content)) {
    node.content = node.content
      .map(removeEmptyTextNodes)
      .filter(child => !(child.type === 'text' && !child.text?.trim()))
  }
  return node
}

export const convertDraftToTiptap = (draftContent: string) => {
  const defaultConverter = new DraftConverter()
  const defaultMapEntityToMark = defaultConverter.options.mapEntityToMark
  const defaultMapInlineStyleToMark =
    defaultConverter.options.mapInlineStyleToMark
  const defaultMapBlockToNode = defaultConverter.options.mapBlockToNode

  try {
    const parsedDraft =
      typeof draftContent === 'string' ? JSON.parse(draftContent) : draftContent

    parsedDraft.blocks = parsedDraft.blocks.map(
      (block: RawDraftContentBlock) => {
        if (block.type === 'section') {
          return { ...block, type: 'unstyled' }
        }
        return block
      },
    )

    const draftConverter = new DraftConverter({
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-expect-error
      mapEntityToMark: params => {
        const { range, entityMap, block } = params
        const entityKey = block.entityRanges.find(
          ({ key }: { key: number }) => key === range.key,
        )

        if (!entityKey) {
          return defaultMapEntityToMark?.(params) || null
        }

        const entity = entityMap[entityKey.key]

        if (entity.type === 'LINK') {
          const data = entity.data
          return {
            type: 'link',
            attrs: {
              popupid: data.popupId,
              href: data.url || null,
              target: data.target,
              rel: data.rel,
            },
          }
        }

        return defaultMapEntityToMark?.(params) || null
      },
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-expect-error
      mapInlineStyleToMark: params => {
        if (params.range.style.includes('rgba')) {
          return {
            type: 'textStyle',
            attrs: {
              color: params.range.style,
            },
          }
        }

        return defaultMapInlineStyleToMark?.(params) || null
      },
      // Mapping a block does not have to be a one-to-one mapping, it can be a many-to-one mapping
      // @ts-expect-error
      mapBlockToNode(params) {
        const { block, next, peek, converter, entityMap, doc } = params

        if (block.type === 'unordered-list-item') {
          // Create a single bulletList node
          const listNode = converter.createNode('bulletList')

          // Process all consecutive unordered-list-item blocks
          while (block) {
            // Create a listItem node for the current block
            const itemNode = converter.createNode('listItem', {
              content: [
                converter.createNode('paragraph', {
                  content:
                    converter.splitTextByEntityRangesAndInlineStyleRanges({
                      block,
                      entityMap,
                      doc,
                    }),
                }),
              ],
            })

            // Add the listItem node to the bulletList
            converter.addChild(listNode, itemNode)

            if (peek?.type !== 'unordered-list-item') {
              break
            }

            next()
          }

          // Return the grouped bulletList node
          return listNode
        }

        // Fallback to the default block-to-node mapping
        return defaultMapBlockToNode?.(params) || null
      },
    })

    const result = draftConverter.convert(parsedDraft)

    return removeEmptyTextNodes(result)
  } catch {
    return ''
  }
}
